import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'

const initialState = () => {
  return {
    module: 'cameras',
    model: 'camera',
    loading: false,
    list: [],
    camStatus: [],
    selected: {
      active: true,
      name: '',
      description: '',
      rtspPath: '',
      stadiumId: '',
      ugaId: '',
      ip: '192.168.1.101',
      username: '',
      password: '',
      rtspPort: 554,
      httpPort: 10000,
      recordingSize: 50,
      httpRestartPath:
        '/stw-cgi/system.cgi?msubmenu=power&action=control&Type=Restart',
      recordingSchedules: [],
    },
    idSelected: '',
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    let activeList = state.list.filter((item) => item.active)
    return activeList.map((item) => ({
      value: item._id,
      text: item.name,
    }))
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        active: item.active,
        name: item.name,
        description: item.description,
        rtspPath: item.rtspPath,
        status: item.status,
        stadium: item.stadiumId ? item.stadiumId.name : '-',
        uga: item.ugaId ? item.ugaId.name : '-',
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      return result
    })
  },
}

const actions = {
  ...baseActions,
  async fetchList({ dispatch, commit, state, rootState }, params = {}) {
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params)
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }

    if (rootState.stadiums.idSelected) {
      body.stadiumId = rootState.stadiums.idSelected
      dispatch('fetchSelectList', {
        stadiumId: rootState.stadiums.idSelected,
        limit: 0,
      })
    }
    if (state.selected.active !== undefined) body.active = 'all'
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module, body, { params: { ...query } })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })
    commit('setList', list)
  },
  async fetchCamStatus({ commit, state }, cameraId) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${cameraId}/camStatus`)
      .finally(() => commit('setLoading', false))
    const list = data.data ? data.data.camStatus : []
    commit('setCamStatus', list)
    return list
  },
}

const mutations = {
  ...baseMutations,
  setCamStatus(state, payload) {
    state.camStatus = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.camStatus.push(item))
    }
  },
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
